import { render, staticRenderFns } from "./BookiesLogos.vue?vue&type=template&id=6b12f31e"
import script from "./BookiesLogos.vue?vue&type=script&lang=js"
export * from "./BookiesLogos.vue?vue&type=script&lang=js"
import style0 from "./BookiesLogos.vue?vue&type=style&index=0&id=6b12f31e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports